/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

 import { LogLevel } from "@azure/msal-browser";


// fetch('authConfig.json').then(response => {
//     console.log("Auth", response)
//      response.json().then(auth => {
//         authConfig = auth
//         this.setState({authConfig: auth});
//     })
// })

    /**
     * Configuration object to be passed to MSAL instance on creation. 
     * For a full list of MSAL.js configuration parameters, visit:
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
     */
    export const msalConfig = {
        // auth: {
        //     clientId: authConfig.auth.clientId, // This is the ONLY mandatory field that you need to supply.
        //     authority: authConfig.auth.authority, // Defaults to "https://login.microsoftonline.com/common"
        //     redirectUri: authConfig.auth.redirectUri,  //https://uat-phylodash.esr.cri.nz/// You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
        //     postLogoutRedirectUri: authConfig.auth.postLogoutRedirectUri, // Indicates the page to navigate after logout.
        //     navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
        // },
       auth: {
            clientId: "79e112ac-472c-47c6-9935-08542f1ae5f5",
            authority: "https://login.microsoftonline.com/1aa55b22-5f22-4505-bad3-bafb5f7a34cd",
            redirectUri: window.location.origin + "/",  
            postLogoutRedirectUri: "https://phylodash.test.kaas.esr.cri.nz/",
            navigateToLoginRequestUrl: false
            },
        // cache: {
        //     cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        //     storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
        // },
        system: {
            loggerOptions: {
                loggerCallback: (level, message, containsPii) => {
                    if (containsPii) {
                        return;
                    }
                    switch (level) {
                        case LogLevel.Error:
                            console.error(message);
                            return;
                        case LogLevel.Info:
                            console.info(message);
                            return;
                        case LogLevel.Verbose:
                            console.debug(message);
                            return;
                        case LogLevel.Warning:
                            console.warn(message);
                            return;
                    }
                }
            }
        }
    };
    
    /**
     * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
     */
    export const protectedResources = {
        apiTodoList: {
            todoListEndpoint: "http://localhost:5000/",
            scopes: ["api://7f07b7f1-837a-4b72-98c7-e6998b7be843/access_as_user"],
        },
    }
    
    /**
     * Scopes you add here will be prompted for user consent during sign-in.
     * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
     * For more information about OIDC scopes, visit: 
     * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
     */
    export const loginRequest = {
        scopes: [...protectedResources.apiTodoList.scopes]
    };
    
    export const appRoles = {
        TaskUser: "TaskUser",
        TaskAdmin: "TaskAdmin",
        Admin: 'Admin',
        User: 'User',
        SubUser : "SubUser"
    }
    